import React, { useState } from "react";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { FormItem, ButtonItem, InputNumberItem, SelectInsumosItem, round2Decimals, MensajeError } from "../../../../Components/Items";

let consecutivo = 0;
const nuevaKey = () => `${Date.now()}_${consecutivo++}`;

const InsumosFueraDeListaPU = ({ empresaId, headersToken, insumos = [], onChange }) => {
  const [agregandoMatriz, setAgregandoMatriz] = useState(false);
  const [matrizSeleccionada, setMatrizSeleccionada] = useState(null);
  const [piezasMatriz, setPiezasMatriz] = useState(null);

  const cambiar = (key, cambios) => onChange(insumos.map((i) => (i.key === key ? { ...i, ...cambios } : i)));
  const eliminar = (key) => onChange(insumos.filter((i) => i.key !== key));
  const agregarSuelto = () =>
    onChange([...insumos, { key: nuevaKey(), insumoId: null, clave: "", descripcion: "", unidad: "", cantidad: null, origenMatriz: null }]);

  const cerrarMatriz = () => {
    setAgregandoMatriz(false);
    setMatrizSeleccionada(null);
    setPiezasMatriz(null);
  };

  const confirmarMatriz = () => {
    if (!matrizSeleccionada || !piezasMatriz || piezasMatriz <= 0) {
      MensajeError({ message: "Elige una matriz y captura las piezas a producir" });
      return;
    }
    const origenMatriz = { clave: matrizSeleccionada.clave, descripcion: matrizSeleccionada.descripcion };
    const renglones = (matrizSeleccionada.insumosUtilizarResuelto || [])
      .filter((h) => h.insumo)
      .map((h) => ({
        key: nuevaKey(),
        insumoId: h.insumo._id,
        clave: h.insumo.clave,
        descripcion: h.insumo.descripcion,
        unidad: h.insumo.unidad?.nombre || "",
        cantidad: round2Decimals((h.cantidad || 0) * piezasMatriz),
        origenMatriz,
      }));
    onChange([...insumos, ...renglones]);
    cerrarMatriz();
  };

  return (
    <div style={{ marginTop: 16, paddingTop: 12, borderTop: "1px dashed #d9d9d9" }}>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Insumos fuera de lista</div>

      {insumos.length > 0 && (
        <table className="table table-12px" style={{ marginBottom: 10 }}>
          <thead>
            <tr>
              <th className="th-border">Insumo</th>
              <th className="th-border" style={{ width: 130 }}>
                Cantidad
              </th>
              <th className="th-border" style={{ width: 90 }}>
                Unidad
              </th>
              <th className="th-border" style={{ width: 50 }}></th>
            </tr>
          </thead>
          <tbody>
            {insumos.map((insumo) => (
              <tr key={insumo.key}>
                <td className="td-border" style={{ textAlign: "left" }}>
                  {insumo.clave || insumo.descripcion ? (
                    <p style={{ margin: 5 }}>
                      {insumo.clave ? insumo.clave + " - " : ""}
                      {insumo.descripcion}
                      {insumo.origenMatriz && <span style={{ color: "#999", fontSize: 12 }}> (de {insumo.origenMatriz.descripcion})</span>}
                    </p>
                  ) : (
                    <FormItem noStyle>
                      <SelectInsumosItem
                        className="select-insumo-wrap"
                        empresaId={empresaId}
                        headersToken={headersToken}
                        tiposInsumos="inventariables"
                        sinBorde
                        width="100%"
                        dropdownMatchSelectWidth={600}
                        placeholder="Elige un insumo"
                        value={insumo.insumoId}
                        onChange={(insumoId, insumoObj) =>
                          cambiar(insumo.key, {
                            insumoId,
                            clave: insumoObj?.clave,
                            descripcion: insumoObj?.descripcion,
                            unidad: insumoObj?.unidad?.nombre || insumoObj?.unidad || "",
                          })
                        }
                      />
                    </FormItem>
                  )}
                </td>
                <td className="td-border" style={{ padding: 0 }}>
                  <InputNumberItem
                    sinBorde
                    style={{ width: "100%" }}
                    min={0.0001}
                    placeholder="Cantidad"
                    value={insumo.cantidad}
                    onChange={(valor) => cambiar(insumo.key, { cantidad: valor })}
                  />
                </td>
                <td className="td-border" style={{ textAlign: "center", color: "#999" }}>
                  {insumo.unidad}
                </td>
                <td className="td-border" style={{ textAlign: "center" }}>
                  <ButtonItem type="default" rojo size="small" icon={<DeleteOutlined />} onClick={() => eliminar(insumo.key)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {agregandoMatriz ? (
        <div style={{ background: "#fafafa", padding: 10, borderRadius: 6, marginBottom: 8 }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
            <div style={{ flex: 1 }}>
              <FormItem noStyle>
                <SelectInsumosItem
                  className="select-insumo-wrap"
                  empresaId={empresaId}
                  headersToken={headersToken}
                  tiposInsumos="matrices"
                  width="100%"
                  dropdownMatchSelectWidth={600}
                  placeholder="Elige una matriz"
                  value={matrizSeleccionada?._id}
                  onChange={(_, insumoObj) => setMatrizSeleccionada(insumoObj)}
                />
              </FormItem>
            </div>
            <InputNumberItem style={{ width: 110 }} min={0.0001} placeholder="Piezas" value={piezasMatriz} onChange={setPiezasMatriz} />
          </div>
          <div style={{ textAlign: "right" }}>
            <ButtonItem size="small" style={{ marginRight: 8 }} onClick={cerrarMatriz}>
              Cancelar
            </ButtonItem>
            <ButtonItem size="small" type="primary" mostaza onClick={confirmarMatriz}>
              Agregar sus insumos
            </ButtonItem>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", gap: 8 }}>
          <ButtonItem size="small" icon={<PlusOutlined />} onClick={agregarSuelto}>
            Agregar insumo suelto
          </ButtonItem>
          <ButtonItem size="small" icon={<PlusOutlined />} onClick={() => setAgregandoMatriz(true)}>
            Agregar matriz completa
          </ButtonItem>
        </div>
      )}
    </div>
  );
};

export default InsumosFueraDeListaPU;
